export default function About() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
          关于五一吃瓜网
        </h2>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
            <i className="ri-emotion-laugh-line text-primary-500 text-2xl"></i>
          </div>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mx-auto">
            五一吃瓜网创立于对网络热门事件的深度追踪需求，致力于为吃瓜群众打造一个专业、全面、及时的热门事件追踪平台。
            我们每日监控全网热搜事件与网络热点，聚合<span className="text-primary-600 font-medium">网络热门事件</span>、
            <span className="text-primary-600 font-medium">吃瓜事件汇总</span>与
            <span className="text-primary-600 font-medium">热门爆料</span>，
            从娱乐圈八卦到社会热点深度追踪，从直播翻车到网红人设崩塌——
            每一个引发全网热议的<span className="text-primary-600 font-medium">网络大事件</span>，我们都为你完整记录。
            不站队、不煽动，只做最客观的吃瓜事件汇总与最新网络热点整理，让每一次吃瓜都明明白白。
          </p>
        </div>
      </div>
    </section>
  );
}